module.exports = "http://cdn.realive.com.ua/src/views/player/documets/images/female.png";